import { render, staticRenderFns } from "./NewFilePage.vue?vue&type=template&id=56bfbf7c&scoped=true"
import script from "./NewFilePage.vue?vue&type=script&lang=js"
export * from "./NewFilePage.vue?vue&type=script&lang=js"
import style0 from "./NewFilePage.vue?vue&type=style&index=0&id=56bfbf7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bfbf7c",
  null
  
)

export default component.exports